import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { MrpProcessInstanceHdrContainerModel } from '../../../../../../models/aggregates/mrp-prodsys';
import { MrpProcessInstanceHdrOrderByLvlDto } from '../../../../../../models/aggregates/mrp-prodsys';
import { ApiResponseModel, ApiVisa, BasicApiResponseModel } from '../../shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MrpProcessInstanceHdrService extends BaseApiTemplateService<MrpProcessInstanceHdrContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-process-instance-hdr";

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-process-instance-hdr";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-process-instance-hdr";
    this.httpClient = http;
  }

  public updateProcessStatus(container: MrpProcessInstanceHdrContainerModel, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + "/update-process-status/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    return this.httpClient.put<BasicApiResponseModel<MrpProcessInstanceHdrContainerModel>>
      (url, container, this.getHttpHeader(visa));
  }

  public createMultiProcessInstance(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/instances-with-lines/backoffice-ep';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public getMrpProcessInstanceHdrFromJobOrderHdrGuid(guid: string, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/' + Core2Config.BACKOFFICE_EP_SUFFIX + '/ordered-by-level/' + guid;
    return this.httpClient.get<BasicApiResponseModel<MrpProcessInstanceHdrOrderByLvlDto[]>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  public getReverseLevelForMrpProcessInstanceHdr(guid: string, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/' + Core2Config.BACKOFFICE_EP_SUFFIX + '/fetch-reverse-level/' + guid;
    return this.httpClient.get<BasicApiResponseModel<any>>(
      url,
      this.getHttpHeader(visa)
    );
  }

}
